import React from 'react';

import { Box, Typography } from '@mui/joy';

export interface BatteryStatusProps {
  batteryPercent: number; // 0..100
}

const getColor = (percent: number) => {
  if (percent < 20) return 'bg-red-700';
  if (percent < 50) return 'bg-yellow-600';
  return 'bg-green-700';
};

const BatteryStatus: React.FC<BatteryStatusProps> = ({ batteryPercent }) => (
  <Box className='w-24'>
    <Typography level='body-xs' className='text-right'>
      {batteryPercent}%
    </Typography>
    <Box className='relative h-3 w-full bg-neutral-700 border border-neutral-500 rounded-sm'>
      <Box className={`h-full ${getColor(batteryPercent)}`} style={{ width: `${batteryPercent}%` }} />
    </Box>
  </Box>
);

export default BatteryStatus;
